import React, { Component } from 'react';
import {UISref,UISrefActive} from 'ui-router-react'; 
import {createMarkup} from './Factory';
import logo from '../images/logo.svg';
import close from '../images/close.svg';

class Head extends Component {
	constructor(props) {
		super(props);
		this.menuClick = this.menuClick.bind(this);	
		this.linkClick = this.linkClick.bind(this);	
		this.changeLang = this.changeLang.bind(this);	
		this.handleSubmit = this.handleSubmit.bind(this);	
		//this.searchClick = this.searchClick.bind(this);	
		this.emitChange = this.emitChange.bind(this);	
		this.setEndOfContenteditable = this.setEndOfContenteditable.bind(this);	
		this.handleClose = this.handleClose.bind(this);	
		this.handleCookie = this.handleCookie.bind(this);
		this.state = {
			status: '',
			search:'',
			submit:'',
			search_key:'',
			cookieClass:''
		}
	}
	handleCookie(){
		document.cookie = 'cookieMessage=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';	
		this.setState({
			cookieClass:'close'
		})
	}
	handleClose(){
		this.setState({
			search:''
		});
		document.body.classList.toggle('no-scroll');
	}
	changeLang(){
		let lang_switch = window.lang_switch;
		if(lang_switch!=""){
			window.location.href = lang_switch;
		}
		else{
			let localeKey = document.menuLang;
			let current_url = window.location.href;
			let origin = document.location.origin;
			if(localeKey!=='de'){							
				let new_url = current_url.replace(origin,origin+'/'+localeKey);							
				window.location.href = new_url;
			}
			else{
				let new_url = current_url.replace(origin+'/'+document.language,origin);
				window.location.href = new_url;
			}
		}
	}
	menuClick(){
		let status = (this.state.status==="" || this.state.status==="close" ) ? 'open' : 'close';
		this.setState({
			status:status
		});
        let dis = this;
        window.addEventListener('resize', function(){
            if(dis.state.status==="close") {
                dis.setState({
                    status:""
                });
            }
        })
	}
	linkClick(){
		this.setState({
			status:''
		});
	}
	searchClick(){
		//this.setState({
		//	search:'open'
		//});
		//let dis = this;
		//document.body.classList.toggle('no-scroll');		
		//let textElement = document.getElementById('s_text');
		//setTimeout(function() 
		//{			
			//textElement.focus();
			//dis.setEndOfContenteditable(textElement);
		//}, 0);
	}
	componentDidMount(){
		let button = document.getElementById('search-button');
		let textElement = document.getElementById('s_text');
		let dis = this;
		button.addEventListener('click', function () {
			dis.setState({
				search:'open'
			});
			document.body.classList.toggle('no-scroll');
			textElement.focus();
			dis.setEndOfContenteditable(textElement);
		});

	}
	handleSubmit(e){
		e.preventDefault();
		const {stateService} = this.props.transition.router;
		stateService.go("root.search",{item:this.state.search_key});
		this.setState({
			search:''
		});
	}
	emitChange(dis){
		let value = dis.refs.editable.innerHTML;
		
		if(value){
			this.setState({
				submit:'show',
				search_key:value
			});
		}
		else{
			this.setState({
				submit:'',
				search_key:value
			});
		}
		document.getElementById('s_text').addEventListener("keypress", function(event) {			
			if (event.keyCode === 13) {
				event.preventDefault();
				dis.refs['search-submit'].click();
			}
		});
	}
	setEndOfContenteditable(contentEditableElement)
	{
		var range,selection;
		if(document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
		{
			range = document.createRange();//Create a range (a range is a like the selection but invisible)
			range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
			range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
			selection = window.getSelection();//get the selection object (allows you to change selection)
			selection.removeAllRanges();//remove any selections already made
			selection.addRange(range);//make the range you have just created the visible selection
		}
		else if(document.selection)//IE 8 and lower
		{ 
			range = document.body.createTextRange();//Create a range (a range is a like the selection but invisible)
			range.moveToElementText(contentEditableElement);//Select the entire contents of the element with the range
			range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
			range.select();//Select the range (make it the visible selection
		}
	}
  render() {
	const {label_menu_left,label_menu_right,label_search,label_cookies} = this.props.staticData;
	let cookie = true;
	if (document.cookie.indexOf('cookieMessage=true') > -1) {
		cookie = false;
	}
    return (
		<div>
			{
				(cookie) ?
					<div className={`cookie ${this.state.cookieClass} `}>
						<span dangerouslySetInnerHTML={createMarkup(label_cookies)}></span>
						<img alt="close" onClick={this.handleCookie} src={close} />
					</div>
				: null
			}
			<header className="site-header">
				<div className="container-fluid lg-side-padding">
					<div className="row">
						<div className="col-md-12">
							<div className="site-logo">
								<UISref to="root.home">
									<a><img alt="Taxispalais Logo" src={logo} /></a>
								</UISref>
							</div>
							
							<nav className="site-nav">
								<div className="menu-label" role="button" onKeyDown={this.menuClick} onClick={this.menuClick}>
									<span>{label_menu_left} <span className="line"></span></span>
									<span>{label_menu_right}</span>
								</div>
								<ul role="menu" aria-label="Main Navigation" className={`main-menu clearfix ${this.state.status}`}>
									{
										this.props.data.map( (data,i) =>{											
											return(
												<li role="menuitem" key={i} onClick={this.linkClick}>
													{
													(data.children.length) ?
													<UISrefActive  class="active">														
														<UISref to={"root."+data.classes+"."+data.children[0].classes} >
															<a to={"root."+data.classes+"."+data.children[0].classes} id={`menu-${data.classes}`}>{data.title}</a>
														</UISref>
													</UISrefActive>	
													:
													<UISrefActive  class="active">			
														<UISref to={"root."+data.classes} >
															<a id={`menu-${data.classes}`}>{data.title}</a>
														</UISref>
													</UISrefActive>
													}
												</li>
											)
										})
									
									}
									<li aria-label="Language Change" role="menuitem" className="lang" onClick={this.changeLang}>
										<span>
										{document.menuLang}
										</span>
									</li>
									<li id="search-button" className="search" role="search" aria-label="Search"><i className="icon-search"></i></li>
                                    <li onClick={this.menuClick} className="icon-close-white"></li>
								</ul>
							</nav>	
						</div>
					</div>
				</div>
			</header>	
			<div className={`fixed-overlay ${this.state.search}`} id="search-overlay">
				<i className="close-overlay icon-close-white" onClick={this.handleClose}></i>
				<form className="search-form" id="search-form" onSubmit={this.handleSubmit}>
					<div className="search-input-wrapper">
						<span className="sr-only" aria-label="Search this site"></span>
						<div ref="editable" id="s_text" className="search-input" onInput={ () => this.emitChange(this) } onBlur={ () => this.emitChange(this) } contentEditable="true"></div>
					</div>
					<input ref="search-submit" className={`search-submit ${this.state.submit}`} type="submit" value={label_search} />
				</form>
			</div>	
		</div>
		
    );
  }
}

export default Head;



// WEBPACK FOOTER //
// ./src/components/Head.js